import { defineMessages } from 'react-intl'

export default defineMessages({
    createVersion: {
        id: 'containers.AuditionScopePage.createVersion',
        defaultMessage: '+ Create version',
    },
    copyCustomerOverviewLink: {
        id: 'containers.AuditionScopePage.copyCustomerLink',
        defaultMessage: 'Copy link for customer overview',
    },
    copyCustomerPublicLink: {
        id: 'containers.AuditionScopePage.copyCustomerPublicLink',
        defaultMessage: 'Copy link for public overview',
    },
    copySuccess: {
        id: 'containers.AuditionScopePage.copySuccess',
        defaultMessage: 'Link copied',
    }
})
